import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var displayMedium = designTokenFonts.displayMedium,
  bodyFont = designTokenFonts.body,
  bodyBold = designTokenFonts.bodyBold,
  mini = designTokenFonts.mini;
var colours = tokens.colors;
export var container = bgColour => /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:space-between;background-color:", bgColour || colours.neutral.surface.default, ";width:100%;max-width:725px;padding:20px;height:auto;", media('>=tablet'), "{min-height:303.2px;background-color:", bgColour || colours.neutral.subdued.default, ";}");
export var header = textColour => /*#__PURE__*/css(displayMedium, ";color:", textColour, ";margin:10px 0;");
export var body = textColour => /*#__PURE__*/css(bodyFont, ";color:", textColour, ";margin:20px 0 30px;");
export var button = textColour => /*#__PURE__*/css(bodyBold, ";color:", textColour, ";text-decoration:none;padding:10px 40px;border:1px solid white;border-radius:2px;display:inline-block;position:relative;width:100%;text-align:center;", media('>=tablet'), "{width:260px;}");
export var buttonContainer = /*#__PURE__*/css("width:100%;text-align:center;", media('>=tablet'), "{text-align:left;}");
export var disclaimerCopy = textColour => /*#__PURE__*/css(mini, ";color:", textColour, ";");
export var logo = {
  name: "i96hd5",
  styles: "margin-bottom:-5px;padding-left:20px;"
};
export var flexContainer = {
  name: "ri8p2s",
  styles: "display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;margin-top:30px;"
};